import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarCommentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    className="Icon toolbar-comment"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect width={32} height={32} fill="#1B2536" rx={4} />
      <path
        fill="#48505E"
        d="M18.25 9a.75.75 0 1 1 0 1.5H9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h4.621l2.202 2.202a.25.25 0 0 0 .3.04l.054-.04 2.202-2.202H23a.5.5 0 0 0 .5-.5v-4.25a.75.75 0 1 1 1.5 0V20a2 2 0 0 1-2 2h-4l-2.646 2.646a.5.5 0 0 1-.708 0L13 22H9a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm.976 7c.428 0 .774.336.774.75 0 .38-.291.693-.669.743l-.105.007h-7.452a.76.76 0 0 1-.774-.75c0-.38.291-.693.669-.743l.105-.007zm1.008-3c.423 0 .766.336.766.75 0 .38-.288.693-.662.743l-.104.007h-8.468a.76.76 0 0 1-.766-.75c0-.38.288-.693.662-.743l.104-.007zm4.016-6.5a.75.75 0 0 1 .743.648L25 7.25V9h1.75a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.648.743l-.102.007H25v1.75a.75.75 0 0 1-.648.743L24.25 13a.75.75 0 0 1-.743-.648l-.007-.102V10.5h-1.75a.75.75 0 0 1-.743-.648L21 9.75a.75.75 0 0 1 .648-.743L21.75 9h1.75V7.25a.75.75 0 0 1 .55-.723l.098-.02z"
      />
    </g>
  </svg>
);
const Memo = memo(ToolbarCommentIcon);
export default Memo;